import React, { useState, useEffect } from "react";
import apiService from "../../config";
import { Send, FileText } from 'lucide-react';
import { useLanguage } from "../../StoreContext/LanguageContext";
import LandAcquisitionNotice from '../../Pages/CompensationNotices';

const RailwayWorkersJudgment = ({ onBack, projectId, setSubComponent }) => {
    const { language, translations } = useLanguage();

    const [loading, setLoading] = useState(false);
    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [currentProjectName, setCurrentProjectName] = useState(null);
    const [currentProposalId, setCurrentProposalId] = useState(null);
    const [currentLaoId, setCurrentLaoId] = useState(null);
    const [isTehsildarButtonClicked, setIsKJPButtonClicked] = useState(false);
    const [userRole, setUserRole] = useState(null);
    const [finalAwardData, setFinalAwardData] = useState([]);
    const [selectedButton, setSelectedButton] = useState(null); 

    // 37(2)
    const [showCompensationNotice, setShowCompensationNotice] = useState(false);
    const [selectedOwnerId, setSelectedOwnerId] = useState(null);

    // DSLR
    const [showSendToDSLRModal, setshowSendToDSLRModal] = useState(false);
    const [selectedDocumentDSLR, setselectedDocumentDSLR] = useState(null);
    const [remarksDSLR, setremarksDSLR] = useState('Approved');
    const [sendingToDSLR, setsendingToDSLR] = useState(false);
    const [usersDSLR, setusersDSLR] = useState([]);
    const [loadingusersDSLR, setLoadingusersDSLR] = useState(false);
    const [selectedUserDSLR, setselectedUserDSLR] = useState('');
    // Button Status
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmConfig, setConfirmConfig] = useState({
        title: '',
        message: '',
        onConfirm: null,
        onCancel: null,
        type: 'warning'
    });

    const [proposalData, setProposalData] = useState(null);

    useEffect(() => {
        // if (currentProjectId && currentProposalId) {
        //     fetchFinalAwardButtonStatus();
        // }
        fetchProposalData();
    }, [currentProjectId, currentProposalId]);

    // ✅ Get Project & Proposal ID same as FinalReward
    useEffect(() => {
        const getProjectId = () => {
            const currentProjectData = localStorage.getItem("currentProjectData");
            if (currentProjectData) {
                const projectData = JSON.parse(currentProjectData);
                const currentProjectName = projectData.project_name;
                setCurrentProjectName(currentProjectName);
                return projectData.default_project || projectData.id;
            }

            const userData = localStorage.getItem("userData");
            if (userData) {
                const user = JSON.parse(userData);
                return user.default_project || user.data?.project_id || user.project_id;
            }

            return projectId || "";
        };

        const getProposalId = () => {
            const userData = localStorage.getItem("userData");
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    const laoUserId = user.usr_id;
                    setCurrentLaoId(laoUserId);
                    console.log(".............Current LAO login :", laoUserId);
                    return user.default_proposal || "";
                } catch (e) {
                    console.error("Error parsing user data for proposalId:", e);
                }
            }
            return "";
        };

        const detectedProjectId = getProjectId();
        const detectedProposalId = getProposalId();

        setCurrentProjectId(detectedProjectId);
        setCurrentProposalId(detectedProposalId);

        console.log("✅ Detected Project ID:", detectedProjectId);
        console.log("✅ Detected Proposal ID:", detectedProposalId);
    }, [projectId]);

    // ✅ Get user role
    useEffect(() => {
        try {
            const userData = localStorage.getItem("userData");
            if (userData) {
                const user = JSON.parse(userData);
                setUserRole(user.user_role || user.user_role_name || null);
            }
        } catch (err) {
            console.error("Error parsing user data:", err);
        }
    }, []);

    // ProposalData
    const fetchProposalData = () => {
        try {
            const storedProposal = JSON.parse(localStorage.getItem('selectedProposal') || '{}');
            setProposalData(storedProposal || {});
        } catch (error) {

        }
    };

    // Tracking Button
    useEffect(() => {
        fetchusersDSLR();
    }, []);

    useEffect(() => {
        if (currentProjectId && currentProposalId) {
            fetchButtonStatus();
        }
    }, [currentProjectId, currentProposalId]);

    // fetch DSLR users
    const fetchusersDSLR = async () => {
        setLoadingusersDSLR(true);
        try {
            const response = await apiService.getAllUserRoleSLR();
            console.log('DSLR users:', response);
            if (response.status === 200 && response.data) {
                setusersDSLR(Array.isArray(response.data) ? response.data : []);
            } else {
                setusersDSLR([]);
            }
        } catch (error) {
            console.error('Error fetching DSLR users:', error);
            setusersDSLR([]);
        } finally {
            setLoadingusersDSLR(false);
        }
    };

    const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
        setConfirmConfig({ title, message, onConfirm, onCancel, type });
        setShowConfirmModal(true);
    };

    // Handle Send to DSLR
    const handleSendToDSLR = async () => {
        if (!selectedUserDSLR || !selectedDocumentDSLR) {
            alert('Please select a user and upload a document to send to DSLR Officer.');
            return;
        }

        if (!currentProjectId || !currentProposalId) {
            alert('Project ID and Proposal ID are required.');
            return;
        }

        setsendingToDSLR(true);

        try {
            const formData = new FormData();
            formData.append('project_id', currentProjectId);
            formData.append('proposal_id', currentProposalId);
            formData.append('remarks', remarksDSLR);
            formData.append('usr_id', selectedUserDSLR);
            formData.append('document', selectedDocumentDSLR);

            const response = await apiService.postTrackingDslrKjp(formData);
            console.log('Send to DSLR response:', response);

            if (response.status === 200) {
                alert(
                    translations[language]?.SuccessfullySentToDSLROfficer
                    || "Successfully sent to DSLR Officer!"
                );
                setshowSendToDSLRModal(false);
                setselectedUserDSLR('');
                setremarksDSLR('Approved');
                setselectedDocumentDSLR(null);
                fetchButtonStatus();

            } else {
                alert('Failed to send to DSLR Officer. Please try again.');
            }
        } catch (error) {
            console.error('Error sending to DSLR:', error);
            alert('Failed to send to DSLR Officer. Please try again.');
        } finally {
            setsendingToDSLR(false);
        }
    };

    // Button Disable
    const fetchButtonStatus = async () => {
        try {
            if (!currentProjectId || !currentProposalId) return;

            // setLoading(true);
            let response = await apiService.getDslrKjpButton(currentProjectId, currentProposalId);
            setButtonDisabled(!response.buttonDisable);

        } catch (error) {
            console.error("Error fetching DSLR button state:", error);
        } finally {
            // setLoading(false); // Only set loading to false for main data fetch
        }
    };

    return (
        <div className="p-6 bg-white min-h-screen flex flex-col items-center justify-start">
            <div className="flex space-x-4">
                {/* CompensationAmount */}
                <button
                    className="flex items-center px-4 py-2 rounded-xl shadow-lg transition-all duration-200 bg-yellow-700 hover:bg-yellow-800 text-white"
                    onClick={() => {
                        setSelectedOwnerId('all'); // Set ownerId to 'all' to fetch and display all owners
                        setShowCompensationNotice(true); // Show the CompensationNotices modal
                    }}
                >
                    <FileText className="h-5 w-5 mr-2" />
                    {translations[language].kalam37_2}
                </button>

                {/* Kabja pauti */}
                <button
                    className="flex items-center px-4 py-2 rounded-xl shadow-lg transition-all duration-200 bg-yellow-700 hover:bg-yellow-800 text-white"
                    onClick={() => {
                        setSubComponent("KabjaPauti")
                    }}
                >
                    {translations[language].KabjaPauti}
                </button>

                {/* Form Seel */}
                <button
                    className="flex items-center px-4 py-2 rounded-xl shadow-lg transition-all duration-200 bg-yellow-700 hover:bg-yellow-800 text-white"
                    onClick={() => {
                        setSubComponent("FormC")
                    }}
                >
                    {translations[language].formSell}
                </button>

                {/* ✅ भूसंपादन प्रमाणपत्र Button */}
                <button
                    className="flex items-center px-4 py-2 rounded-xl shadow-lg transition-all duration-200 bg-yellow-700 hover:bg-yellow-800 text-white"
                    onClick={() => setSubComponent("LandAcquisitionCerti")}
                >
                    {translations[language].LandAcquisitionCerti}
                </button>

                {/* ✅ Send to DSLR */}
                {userRole === 3 && (
                    <button
                        type="button"
                        onClick={() => {
                            if (buttonDisabled) {
                                showConfirm(
                                    translations[language]?.confirmResubmission,
                                    translations[language]?.resubmissionWarning,
                                    () => {
                                        // what should happen on confirm
                                        setshowSendToDSLRModal(true);
                                    },
                                    () => {
                                        // optional cancel callback
                                        console.log("Resend cancelled");
                                    },
                                    "danger" // modal color type
                                );
                            } else {
                                setshowSendToDSLRModal(true);
                            }
                        }}
                        className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                            ? "bg-red-600 text-white hover:bg-red-700"
                            : "bg-purple-600 text-white hover:bg-purple-700"
                            }`}
                        title={
                            buttonDisabled
                                ? translations[language]?.AlreadySentToDSLROfficerClickToResend
                                : translations[language]?.SendToDSLROfficer
                        }
                    >
                        <Send className="mr-2 h-4 w-4" />
                        <span>{translations[language]?.sendToKJP}</span>
                    </button>
                )}
            </div>

            {/* Message if none selected */}
            {!selectedButton && (
                <p className="text-gray-600 text-center mt-4 italic">
                    ⚠️ Please select an option above to continue.
                </p>
            )}

            {/* Send to DSLR Modal */}
            {showSendToDSLRModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="p-6">

                            {/* <div className="flex justify-between items-center mb-6"> */}
                            {/* <h3 className="text-xl font-semibold text-gray-800">
                              {translations[language]?.SendToDSLROfficer}
                            </h3> */}
                            {/* <button
                              onClick={() => setshowSendToDSLRModal(false)}
                              className="text-gray-400 hover:text-gray-600"
                            >
                              <X className="h-6 w-6" />
                            </button> */}
                            {/* </div> */}

                            <div className="space-y-4">
                                {/* User Selection */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.selectUserDSLROfficer} *
                                    </label>
                                    <select
                                        value={selectedUserDSLR}
                                        onChange={(e) => setselectedUserDSLR(e.target.value)}
                                        disabled={loadingusersDSLR}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    >
                                        <option value="">
                                            {loadingusersDSLR ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                                        </option>
                                        {usersDSLR.map((user) => (
                                            <option key={user.usr_id} value={user.usr_id}>
                                                {user.full_name} ({user.usr_role})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Remarks */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {translations[language]?.Remarks}
                                    </label>
                                    <textarea
                                        value={remarksDSLR}
                                        onChange={(e) => setremarksDSLR(e.target.value)}
                                        rows={3}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        placeholder="Enter remarks..."
                                    />
                                </div>

                                {/* Document Upload */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Upload Document *
                                    </label>
                                    <input
                                        type="file"
                                        onChange={(e) => setselectedDocumentDSLR(e.target.files[0])}
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                    />
                                </div>
                            </div>

                            {/* Modal Actions */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button
                                    onClick={() => {
                                        setshowSendToDSLRModal(false);
                                    }} className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    disabled={sendingToDSLR}
                                >
                                    {translations[language]?.Cancel}
                                </button>
                                <button
                                    onClick={handleSendToDSLR}
                                    disabled={sendingToDSLR || !selectedUserDSLR || !selectedDocumentDSLR}
                                    className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                                >
                                    {sendingToDSLR ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                            {translations[language]?.sending}
                                        </>
                                    ) : (
                                        <>
                                            <Send className="mr-2 h-4 w-4" />
                                            {translations[language]?.CommonSave}
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Confirmation Modal */}
            {showConfirmModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
                        <div className="p-6">
                            <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                                confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                                    'bg-blue-100'
                                }`}>
                                {confirmConfig.type === 'danger' ? '⚠' :
                                    confirmConfig.type === 'warning' ? '⚠' : '?'}
                            </div>

                            <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                                {confirmConfig.title}
                            </h3>

                            <p className="text-gray-600 text-sm mb-6 text-center">
                                {confirmConfig.message}
                            </p>

                            <div className="flex gap-3">
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onCancel) confirmConfig.onCancel();
                                    }}
                                    className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                                >
                                    {translations[language]?.Cancel}
                                </button>
                                <button
                                    onClick={() => {
                                        setShowConfirmModal(false);
                                        if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                                    }}
                                    className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                                        confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                                            'bg-blue-600 hover:bg-blue-700'
                                        }`}
                                >
                                    {translations[language]?.confirm}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showCompensationNotice && (
                <LandAcquisitionNotice
                    ownerId={selectedOwnerId} // Will be 'all' for all owners
                    currentProjectName={currentProjectName}
                    currentProjectId={currentProjectId}
                    currentProposalId={currentProposalId}
                    isVisible={showCompensationNotice}
                    proposalData={proposalData}
                    onClose={() => {
                        setShowCompensationNotice(false);
                        setSelectedOwnerId(null);
                    }}
                />
            )}
        </div>

    );
};

export default RailwayWorkersJudgment;